import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=072c184e&scoped=true&"
import script from "./FavoriteButton.vue?vue&type=script&lang=ts&"
export * from "./FavoriteButton.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteButton.vue?vue&type=style&index=0&id=072c184e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c184e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default})
